// Wait for both DOM and jQuery to be ready
$(document).ready(function () {
  // Currency formatting function - will be overridden by Liquid template
  window.formatMoney =
    window.formatMoney ||
    function (amount) {
      return "$" + (amount / 100).toFixed(2);
    };
  // Bundle option selection - Updated for Pack variants
  $('input[name="pack"]').on("change", function () {
    const selectedValue = $(this).val();
    const selectedVariantId = $(this).data("variant-id");
    // Use calculated price when present (e.g. soccer grip socks where all variants share one price)
    const rawPrice = $(this).data("variant-price");
    const calculatedPrice = parseInt($(this).attr("data-calculated-price"), 10);
    const selectedVariantPrice = (!isNaN(calculatedPrice) && calculatedPrice > 0)
      ? calculatedPrice
      : rawPrice;
    const rawCompare = $(this).data("compare-price");
    const calculatedCompare = parseInt($(this).attr("data-calculated-compare-price"), 10);
    const selectedComparePrice = (!isNaN(calculatedCompare) && calculatedCompare > 0)
      ? calculatedCompare
      : rawCompare;

    console.log(
      "Bundle changed - Pack:",
      selectedValue,
      "Variant ID:",
      selectedVariantId,
      "Price:",
      selectedVariantPrice,
      "Compare At:",
      selectedComparePrice
    );

    // Update bundle option styling
    $(".bundle-option").removeClass("selected");
    $(this).closest(".bundle-option").addClass("selected");

    // Update the form variant ID
    if (selectedVariantId) {
      $('input[name="id"]').val(selectedVariantId);
      $('input[id*="variant-id"]').val(selectedVariantId);
    }

    // Convert from cents (prices are in cents)
    const totalPrice = selectedVariantPrice ? selectedVariantPrice / 100 : null;
    const comparePrice = selectedComparePrice
      ? selectedComparePrice / 100
      : null;

    // Update current price
    if (totalPrice) {
      $(".current-price").text(window.formatMoney(selectedVariantPrice));
      $(".btn-price").text(window.formatMoney(selectedVariantPrice));
    }

    // Update original price + savings badge
    if (comparePrice && comparePrice > totalPrice) {
      // Update all .original-price elements
      $(".original-price").each(function () {
        $(this).text(window.formatMoney(selectedComparePrice)).show();
      });

      // Calculate and show save badge
      const saveAmount = selectedComparePrice - selectedVariantPrice;
      $(".save-badge")
        .html(
          `<span class="save-svg">
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0631 0.712463C9.95635 0.746635 9.75771 0.833088 9.62177 0.904503C9.39535 1.0235 8.99934 1.41016 4.906 5.50905C0.640246 9.78063 0.432888 9.99413 0.337045 10.2132C0.157045 10.6248 0.173424 11.1087 0.381913 11.537C0.507832 11.7957 7.13925 18.4272 7.39797 18.5531C7.82625 18.7616 8.31019 18.778 8.72177 18.598C8.94081 18.5022 9.15442 18.2947 13.4262 14.0288C17.6707 9.79023 17.9082 9.54647 18.0383 9.29534C18.304 8.7829 18.2884 9.03411 18.2884 5.26617V1.88525L18.2058 1.65787C18.0449 1.21445 17.7204 0.889959 17.277 0.729019L17.0496 0.646484L13.6535 0.648391C10.5111 0.650156 10.2429 0.654921 10.0631 0.712463ZM13.3281 3.7439C12.9001 3.89676 12.6052 4.16036 12.4166 4.55859C12.3132 4.77675 12.3048 4.82215 12.3048 5.16507C12.3048 5.50848 12.3131 5.55317 12.4173 5.77307C12.5735 6.10292 12.804 6.33775 13.1294 6.49855C13.386 6.62539 13.4089 6.63008 13.7698 6.63008C14.1308 6.63008 14.1537 6.62539 14.4103 6.49855C14.7356 6.33775 14.9661 6.10292 15.1224 5.77307C15.2266 5.55317 15.2348 5.50848 15.2348 5.16507C15.2348 4.82166 15.2266 4.77697 15.1224 4.55707C14.9667 4.22835 14.7355 3.99232 14.4132 3.83304C14.1777 3.71665 14.1161 3.70179 13.8275 3.69183C13.5848 3.68343 13.4613 3.69632 13.3281 3.7439Z" fill="white"/>
        </svg>
      </span>
      Save ${window.formatMoney(saveAmount)}`
        )
        .show();
    } else {
      $(".original-price, .save-badge").hide();
    }
  });

  // Size option selection
  $('input[name="size"]').on("change", function () {
    $(".size-option").removeClass("selected");
    $(this).next(".size-option").addClass("selected");
  });

  // Color option selection
  $(".color-option").on("click", function () {
    $(".color-option").removeClass("selected");
    $(this).addClass("selected");
    $(this).prev('input[type="radio"]').prop("checked", true);
  });

  // Variant selection logic - Updated for Pack variants
  function updateVariant() {
    const selectedPack = $('input[name="pack"]:checked').val();
    const selectedSize = $('input[name="size"]:checked').val();
    const selectedColor = $('input[name="color"]:checked').val();

    // Find matching variant - check if product data is available
    if (typeof product !== "undefined" && product.variants) {
      const matchingVariant = product.variants.find((variant) => {
        let packMatch = true;
        let sizeMatch = true;
        let colorMatch = true;

        // Check pack option
        if (selectedPack) {
          packMatch =
            variant.option1 === selectedPack ||
            variant.option2 === selectedPack ||
            variant.option3 === selectedPack;
        }

        // Check size option
        if (selectedSize) {
          sizeMatch =
            variant.option1 === selectedSize ||
            variant.option2 === selectedSize ||
            variant.option3 === selectedSize;
        }

        // Check color option
        if (selectedColor) {
          colorMatch =
            variant.option1 === selectedColor ||
            variant.option2 === selectedColor ||
            variant.option3 === selectedColor;
        }

        return packMatch && sizeMatch && colorMatch && variant.available;
      });

      if (matchingVariant) {
        $('input[name="id"]').val(matchingVariant.id);
        $('input[id*="variant-id"]').val(matchingVariant.id);

        // Use pack calculated price when present (e.g. soccer grip socks)
        const packInput = $('input[name="pack"]:checked')[0];
        const displayPrice = packInput
          ? (parseInt($(packInput).attr("data-calculated-price"), 10) || matchingVariant.price)
          : matchingVariant.price;
        const displayCompare = packInput
          ? parseInt($(packInput).attr("data-calculated-compare-price"), 10)
          : null;

        $(".current-price").text(window.formatMoney(displayPrice));
        $(".btn-price").text(window.formatMoney(displayPrice));

        if (displayCompare && displayCompare > displayPrice) {
          $(".original-price").each(function () {
            $(this).text(window.formatMoney(displayCompare)).show();
          });
        } else {
          $(".original-price, .save-badge").hide();
        }

        console.log(
          "Updated to variant:",
          matchingVariant.id,
          "Price:",
          window.formatMoney(displayPrice)
        );
      }
    } else {
      // Fallback if product data isn't available in global scope
      console.log("Product data not available, using bundle selection logic");
    }
  }

  // Update variant when pack, size or color changes
  $('input[name="pack"], input[name="size"], input[name="color"]').on(
    "change",
    updateVariant
  );

  // Add to cart form submission - Updated for Pack variants
  // DISABLED: Form submission is now handled in the Liquid template for better variant accuracy
  // This jQuery handler is kept only for Kaching bundle compatibility
  
  // Check if using standard Shopify form (handled in Liquid) or Kaching form (handled here)
  const hasKachingBundle =
    !!document.querySelector("kaching-bundle") ||
    !!document.querySelector("kaching-bundles-block");
  
  if (hasKachingBundle) {
    console.log("🔌 Kaching Bundle detected - using jQuery form handler for Kaching only");
    
    // Flag to prevent double submissions in jQuery handler too
    let jQuerySubmitting = false;
    
    // Use .off() first to prevent double binding if the script runs multiple times
    $("form[data-product-form]")
      .off("submit.kachingHandler") // Use namespaced event
      .on("submit.kachingHandler", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        if (jQuerySubmitting) {
          console.log("⏸️ jQuery handler: Submission already in progress");
          return false;
        }
        
        jQuerySubmitting = true;

        const formData = new FormData(this);
        const variantId = formData.get("id");

        console.log("=== KACHING CART SUBMISSION DEBUG ===");
        console.log("Form data variant ID:", variantId);
        console.log("Quantity:", formData.get("quantity"));

        // Kaching Bundle - preserve quantity from form
        console.log(
          "⚠️ Kaching Bundle - PRESERVING quantity from form:",
          formData.get("quantity")
        );

        const selectedPack = $('input[name="pack"]:checked').val();
        console.log(
          "Adding to cart - Pack size:",
          selectedPack,
          "Variant ID:",
          variantId
        );

        fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => {
            console.log("Cart response status:", response.status);
            return response.json();
          })
          .then((data) => {
            console.log("Product added to cart:", data);
            // Update cart count or show success message
            if (typeof window.theme !== "undefined" && window.theme.cart) {
              window.theme.cart.updateCartCount();
            }

            // Dispatch custom cart updated event
            document.dispatchEvent(new CustomEvent("cartUpdated"));

            // Refresh cart contents and open drawer
            console.log("Refreshing cart contents...");

            // Use the theme's built-in cart refresh function
            if (typeof window.refreshCart === "function") {
              window.refreshCart();
            } else {
              // Fallback: manually refresh cart contents
              fetch("?section_id=helper-cart")
                .then((response) => response.text())
                .then((text) => {
                  const sectionInnerHTML = new DOMParser().parseFromString(
                    text,
                    "text/html"
                  );
                  const cartFormInnerHTML =
                    sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
                  const cartSubtotalInnerHTML =
                    sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

                  if (document.getElementById("AjaxCartForm")) {
                    const cartItems = document.getElementById("AjaxCartForm");
                    cartItems.innerHTML = cartFormInnerHTML;
                    cartItems.ajaxifyCartItems();

                    document.getElementById("AjaxCartSubtotal").innerHTML =
                      cartSubtotalInnerHTML;

                    // Update cart count
                    document
                      .querySelectorAll("[data-header-cart-count]")
                      .forEach((elm) => {
                        elm.textContent = document.querySelector(
                          "#AjaxCartForm [data-cart-count]"
                        ).textContent;
                      });
                    document
                      .querySelectorAll("[data-header-cart-total]")
                      .forEach((elm) => {
                        elm.textContent = document.querySelector(
                          "#AjaxCartForm [data-cart-total]"
                        ).textContent;
                      });
                  }
                })
                .catch((error) => {
                  console.error("Error refreshing cart:", error);
                });
            }

            // Open cart drawer
            console.log("Attempting to open cart drawer...");
            const cartSidebar = document.getElementById("site-cart-sidebar");
            console.log("Cart sidebar element:", cartSidebar);

            if (cartSidebar) {
              console.log("Opening cart drawer...");
              cartSidebar.show();
              if (document.getElementById("cart-recommendations-sidebar")) {
                document
                  .getElementById("cart-recommendations-sidebar")
                  .generateRecommendations();
              }
            } else {
              console.log("Cart sidebar not found!");
            }

            // Update gift tiers after adding to cart (with small delay to ensure cart is updated)
            setTimeout(() => {
              if (typeof window.updateGiftTiers === "function") {
                let productPrice = 0;

                if (typeof product !== "undefined" && product.variants) {
                  const variantId = formData.get("id");
                  const currentVariant = product.variants.find(
                    (v) => v.id == variantId
                  );
                  productPrice = currentVariant ? currentVariant.price / 100 : 0;
                }

                window.updateGiftTiers(productPrice);
              }
            }, 500);
          })
          .catch((error) => {
            console.error("Error adding to cart:", error);
            alert("Error adding product to cart. Please try again.");
          })
          .finally(() => {
            // Re-enable submission after 1 second
            setTimeout(() => {
              jQuerySubmitting = false;
            }, 1000);
          });
        
        return false;
      });
  } else {
    console.log("📝 Standard form detected - using Liquid template form handler");
  }

  const stockStatus = document.querySelector(".stock-status");
  if (!stockStatus) return;

  const daysToAdd = parseInt(stockStatus.dataset.deliveryDays) || 5;
  const today = new Date();
  const deliveryDate = new Date();
  deliveryDate.setDate(today.getDate() + daysToAdd);

  // Format date (e.g. August 31st)
  const options = { month: "long", day: "numeric" };
  const formattedDate = deliveryDate.toLocaleDateString("en-US", options);

  // Add suffix (st, nd, rd, th)
  const day = deliveryDate.getDate();
  const suffix =
    day % 10 == 1 && day != 11
      ? "st"
      : day % 10 == 2 && day != 12
      ? "nd"
      : day % 10 == 3 && day != 13
      ? "rd"
      : "th";

  document.querySelector(
    ".delivery-date"
  ).textContent = `${formattedDate}${suffix}`;

  // Handle image zoom on desktop
  if (window.innerWidth > 768) {
    $(".product-image-container img").on("click", function () {
      const src = $(this).attr("src").replace("width=800", "width=1200");

      // Create zoom overlay
      const zoomOverlay = $(`
        <div class="image-zoom-overlay" style="
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.9);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: zoom-out;
        ">
          <img src="${src}" style="max-width: 90%; max-height: 90%; object-fit: contain;">
        </div>
      `);

      $("body").append(zoomOverlay);

      zoomOverlay.on("click", function () {
        $(this).remove();
      });
    });
  }

  // Size guide modal functionality
  $(".size-guide-link").on("click", function (e) {
    e.preventDefault();
  });

  // Initialize tooltips or additional features as needed
});

// Handle recommendation form submissions with AJAX
$(document).on("submit", "form.recommendation-form", function (e) {
  e.preventDefault();

  const form = this;
  const formData = new FormData(form);
  const productId = form.dataset.productId;

  console.log("=== RECOMMENDATION CART SUBMISSION DEBUG ===");
  console.log("Product ID:", productId);
  console.log("Form data:");
  for (let [key, value] of formData.entries()) {
    console.log(key + ": " + value);
  }

  // Disable button during submission
  const submitButton = form.querySelector('button[type="submit"]');
  const originalText = submitButton.textContent;
  submitButton.disabled = true;
  submitButton.textContent = "Adding...";

  fetch("/cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => {
      console.log("Recommendation cart response status:", response.status);
      return response.json();
    })
    .then((data) => {
      console.log("Recommendation product added to cart:", data);

      // Update cart count or show success message
      if (typeof window.theme !== "undefined" && window.theme.cart) {
        window.theme.cart.updateCartCount();
      }

      // Dispatch custom cart updated event
      document.dispatchEvent(new CustomEvent("cartUpdated"));

      // Refresh cart contents and open drawer
      console.log("Refreshing cart contents...");

      // Use the theme's built-in cart refresh function
      if (typeof window.refreshCart === "function") {
        window.refreshCart();
      } else {
        // Fallback: manually refresh cart contents
        fetch("?section_id=helper-cart")
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser().parseFromString(
              text,
              "text/html"
            );
            const cartFormInnerHTML =
              sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
            const cartSubtotalInnerHTML =
              sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

            if (document.getElementById("AjaxCartForm")) {
              const cartItems = document.getElementById("AjaxCartForm");
              cartItems.innerHTML = cartFormInnerHTML;
              cartItems.ajaxifyCartItems();

              document.getElementById("AjaxCartSubtotal").innerHTML =
                cartSubtotalInnerHTML;

              // Update cart count
              document
                .querySelectorAll("[data-header-cart-count]")
                .forEach((elm) => {
                  elm.textContent = document.querySelector(
                    "#AjaxCartForm [data-cart-count]"
                  ).textContent;
                });
              document
                .querySelectorAll("[data-header-cart-total]")
                .forEach((elm) => {
                  elm.textContent = document.querySelector(
                    "#AjaxCartForm [data-cart-total]"
                  ).textContent;
                });
            }
          })
          .catch((error) => {
            console.error("Error refreshing cart:", error);
          });
      }

      // Open cart drawer
      console.log("Attempting to open cart drawer...");
      const cartSidebar = document.getElementById("site-cart-sidebar");
      console.log("Cart sidebar element:", cartSidebar);

      if (cartSidebar) {
        console.log("Opening cart drawer...");
        cartSidebar.show();
        if (document.getElementById("cart-recommendations-sidebar")) {
          document
            .getElementById("cart-recommendations-sidebar")
            .generateRecommendations();
        }
      } else {
        console.log("Cart sidebar not found!");
      }
    })
    .catch((error) => {
      console.error("Error adding recommendation product to cart:", error);
      alert("Error adding product to cart. Please try again.");
    })
    .finally(() => {
      // Re-enable button
      submitButton.disabled = false;
      submitButton.textContent = originalText;
    });
});

// Handle window resize for responsive behavior
$(window).on("resize", function () {
  // Reinitialize sliders if needed for responsive behavior
  if (window.innerWidth <= 768) {
    $(".product-thumbnails").slick("unslick");
    // Reinitialize for mobile if needed
  }
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".swiper").forEach((swiper) => {
    swiper.style.opacity = "1";
  });
});
